import React, { Component } from 'react';
import axios from 'axios';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';
import FormHOC from 'hoc/FormHOC';
import config from 'config';

// style / context
import { Context } from 'context/Context';
import detailsPageStyle from 'views/Common/style/detailsPageStyle';
import SweetAlert from 'components/SweetModal/SweetAlert';

class ConfirmPro extends Component {
  state = { height: 0, emailsended: false };

  componentDidMount() {
    // if (!this.props.context.state.user)
    this.verifyToken();
    const { handleSnackbar } = this.props.context;
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    const email = params.get('email');
    const token = params.get('hash');
    axios.post(`${config.API_URL}/public/auth/confirm-email`, { email, token }).then(() => {
      return handleSnackbar({
        status: 'success',
        message: 'Compte activé avec succès.',
      });
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  verifyToken = () => {
    const localToken = localStorage.getItem('token');
    if (localToken && localToken !== 'undefined') {
      const token = JSON.parse(localToken);
      localStorage.setItem('token', localToken);
      axios.post(`${config.API_URL}/public/auth/verify_token`, { token }).then((res) => {
        this.props.context.updateUser(res.data.user);
      });
    }
    return null;
  };

  updateWindowDimensions = () => {
    this.setState({ height: window.innerHeight });
  };

  render() {
    const { classes } = this.props;

    const ConfirmProAlert = (
      <SweetAlert
        success
        title='Compte activé avec succés!'
        onConfirm={() => this.props.history.push('/auth/connexion')}
        confirmBtnText='Se connecter'
        text='Vous pouvez dès à présent vous connecter.'
      />
    );
    return (
      <ErrorBoundaries>
        <div className={classes.content}>{ConfirmProAlert}</div>
      </ErrorBoundaries>
    );
  }
}

const WrappedComponent = FormHOC(ConfirmPro);

export default withStyles(detailsPageStyle)((props) => (
  <Context.Consumer>{(context) => <WrappedComponent {...props} context={context} />}</Context.Consumer>
));
